// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--8-1!../../../node_modules/less-loader/dist/cjs.js??ref--8-2!./main.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("1478acb9", content, true);


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/main.less
// module id = 334
// module chunks = 11